import { render, staticRenderFns } from "./AddPaymentMethodToRfidFormModal.vue?vue&type=template&id=8a826f54"
import script from "./AddPaymentMethodToRfidFormModal.vue?vue&type=script&lang=js"
export * from "./AddPaymentMethodToRfidFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports